import { ReactElement, useState, useEffect } from "react"
import { useDebounce } from "react-use"

type Props = {
  min?: number
  max?: number
  value: number
  onChange: (value: number) => void
  unit?: string
  color?: string
  label?: string
  className?: string
  debounceMs?: number
  defaultValue?: number
}

const Slider = ({
  min = 0,
  max = 100,
  value,
  onChange,
  unit = "%",
  color = "",
  label,
  className = "",
  debounceMs = 200,
  defaultValue = 0,
}: Props): ReactElement => {
  const [localValue, setLocalValue] = useState(defaultValue ?? value)

  const percentage = ((localValue - min) / (max - min)) * 100

  useDebounce(() => onChange(localValue), debounceMs, [localValue])

  useEffect(() => {
    setLocalValue(value ?? defaultValue)
  }, [value])

  return (
    <div className={className}>
      <div className="flex text-slate-500 items-center gap-x-2 w-full">
        {label && <span className="text-xs">{label}</span>}

        <input
          type="range"
          min={min}
          max={max}
          value={localValue}
          onChange={e => setLocalValue(Number(e.target.value))}
          className="h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-[var(--interactive-01)]"
          style={{
            background: `linear-gradient(to right, ${color} 0%, ${color} ${percentage}%, #e2e8f0 ${percentage}%, #e2e8f0 100%)`,
          }}
        />

        <span className="text-xs">
          {localValue}
          {unit}
        </span>
      </div>
    </div>
  )
}

export default Slider
